export default __webpack_public_path__ + "static/media/DrawsBanner.f917f96e.jpg";